const LEGACY_LEVEL_TEST_REPORT_IDS = new Set([75, 76, 77]);

export const usesLegacyLevelTestReport = (testIdx) => LEGACY_LEVEL_TEST_REPORT_IDS.has(Number(testIdx));

export const getLevelTestReportPath = (assignedTestUserId, testIdx) =>
  usesLegacyLevelTestReport(testIdx)
    ? `/test/new/${assignedTestUserId}/report-level-test`
    : `/evine/level-test/report/${assignedTestUserId}`;
